// import React, { useState } from "react";
// import GameProjects from "./GameProjects/GameProjects";
// import WebsitesProjects from "./WebsitesProjects/WebsitesProjects";
// import EmailsProjects from "./EmailsProjects/EmailsProjects";
// import BannersProjects from "./BannersProjects/BannersProjects";
// import UXProjects from "./UXProjects/UXProjects";
// import MicrositesProjects from "./MicrositesProjects/MicrositesProjects";

// import { Title, CategoryTabs, Tab } from "./Projects.styles";

// const categories = [
//   "Games",
//   "Websites",
//   "Emails",
//   "Banners",
//   "UX/UI",
//   "Microsites",
// ];

// const Projects = () => {
//   const [activeCategory, setActiveCategory] = useState("Games");

//   return (
//     <section id="projects">
//       <Title>Some Things I’ve Built</Title>
//       <CategoryTabs>
//         {categories.map((category) => (
//           <Tab
//             key={category}
//             $active={activeCategory === category}
//             onClick={() => setActiveCategory(category)}
//           >
//             {category}
//           </Tab>
//         ))}
//       </CategoryTabs>
//       {activeCategory === "Games" && <GameProjects />}
//       {activeCategory === "Websites" && <WebsitesProjects />}
//       {activeCategory === "Emails" && <EmailsProjects />}
//       {activeCategory === "Banners" && <BannersProjects />}
//       {activeCategory === "UX/UI" && <UXProjects />}
//       {activeCategory === "Microsites" && <MicrositesProjects />}
//     </section>
//   );
// };

// export default Projects;

import React, { useState, Suspense, useEffect, startTransition, memo } from "react";
import { ProjectsSection, Title, CategoryTabs, Tab, ContentWrapper } from "./Projects.styles";

// Lazy-load each project section
const GameProjects = React.lazy(() => import("./GameProjects/GameProjects"));
const PersonalProjects = React.lazy(() =>
  import("./PersonalProjects/PersonalProjects")
);
const ClientProjects = React.lazy(() =>
  import("./ClientProjects/ClientProjects")
);

// Project categories
const categories = ["Games", "Personal Projects", "Client Projects"];

// Preload functions
const preload = {
  Games: () => import("./GameProjects/GameProjects"),
  "Personal Projects": () => import("./PersonalProjects/PersonalProjects"),
  "Client Projects": () => import("./ClientProjects/ClientProjects"),
};

// Preload all components immediately (before first render)
if (typeof window !== "undefined") {
  Promise.all([
    preload.Games(),
    preload["Personal Projects"](),
    preload["Client Projects"](),
  ]).catch(() => {
    // Ignore preload errors
  });
}

const Projects = () => {
  const [activeCategory, setActiveCategory] = useState("Games");

  // Ensure components are preloaded
  useEffect(() => {
    Object.values(preload).forEach((preloadFn) => preloadFn());
  }, []);

  const handleCategoryChange = (category) => {
    // Preload before changing
    preload[category]?.();
    // Use startTransition to mark as non-urgent
    startTransition(() => {
      setActiveCategory(category);
    });
  };

  const renderActiveComponent = () => {
    switch (activeCategory) {
      case "Games":
        return <GameProjects />;
      case "Personal Projects":
        return <PersonalProjects />;
      case "Client Projects":
        return <ClientProjects />;
      default:
        return <GameProjects />;
    }
  };

  return (
    <ProjectsSection id="projects">
      <Title>Some Things I’ve Built</Title>

      <CategoryTabs>
        {categories.map((category) => (
          <Tab
            key={category}
            $active={activeCategory === category}
            onClick={() => handleCategoryChange(category)}
            onMouseEnter={() => preload[category]?.()}
          >
            {category}
          </Tab>
        ))}
      </CategoryTabs>

      <ContentWrapper>
        <Suspense
          fallback={
            <div
              style={{
                padding: "2rem",
                textAlign: "center",
                minHeight: "500px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                contain: "layout style",
              }}
            >
              Loading...
            </div>
          }
        >
          <div style={{ contain: "layout style" }}>
            {renderActiveComponent()}
          </div>
        </Suspense>
      </ContentWrapper>
    </ProjectsSection>
  );
};

Projects.displayName = "Projects";

export default memo(Projects);
